import { ActionButton, ActionButtonType } from "@octopusdeploy/design-system-components";
import { Permission } from "@octopusdeploy/octopus-server-client";
import { PermissionCheck } from "~/components/PermissionCheck/index";
interface ProjectTemplatePublishButtonProps {
    onPublish: () => void;
}
export default function ProjectTemplatePublishButton({ onPublish }: ProjectTemplatePublishButtonProps) {
    return (<PermissionCheck permission={Permission.PlatformHubEdit}>
            <ActionButton label="Publish" type={ActionButtonType.Secondary} accessibleName="Publish" onClick={onPublish}/>
        </PermissionCheck>);
}
